import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'ErrorFallback.title',
    defaultMessage: 'Connection trouble',
    description: 'Title text prompting user of connection trouble',
  },
  description: {
    id: 'ErrorFallback.description',
    defaultMessage: 'The site is currently unavailable. We are working on a fix right now.',
    description: 'Description text prompting user of maintenance on the site',
  },
  tryAgain: {
    id: 'ErrorFallback.tryAgain',
    defaultMessage: 'Try again',
    description: 'Button text prompting user of try again after experiencing connection issue',
  },
});
